import React from 'react';
import { Menu } from 'lucide-react';
import './header.css';

const Header = ({ toggleSidebar }) => {
    return (
        <header className="header">
            <div className="header-left">
                {/* <div className="logo-circle">S</div> */}
                <div className="header-title">
                    <img
                        src="./images/logo.webp"
                        alt="Startup Steroid India"
                        className="header-title-main"
                    />
                </div>
            </div>
            <div className="header-right">
                <button className="header-btn client-view">CLIENT VIEW</button>
                <button className="header-btn admin-view">ADMIN VIEW</button>
                <button className="mobile-menu-btn" onClick={toggleSidebar}>
                    <Menu size={24} />
                </button>
            </div>
        </header>
    );
};

export default Header;
